import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import Checkbox from '../Checkbox';
import withStyles from '../withStyles';
import styles from './MultiSelectFieldOption.styles';
const MultiSelectFieldOption = ({ value, label, rightLabel, selectable = false, disabled = false, checked = false, selected = false, onClick = () => { }, onSelect, classes, }) => (_jsx("button", Object.assign({ className: cn(classes.root, disabled && classes.disabled), onClick: (e) => {
        e.preventDefault();
        if (onSelect) {
            onSelect({ value, label, rightLabel });
        }
        else {
            onClick();
        }
    }, disabled: disabled }, { children: _jsx(Checkbox, { className: classes.checkboxLabel, disabled: disabled, checked: checked, label: _jsxs("span", Object.assign({ className: cn(classes.label, {
                [classes.selected]: selected,
                [classes.labelButton]: checked && selectable && !disabled,
            }) }, { children: [_jsx("span", Object.assign({ className: classes.leftLabel }, { children: label || _jsx(_Fragment, { children: "\u00A0" }) })), rightLabel && (_jsx("span", Object.assign({ className: classes.rightLabel }, { children: rightLabel })))] })), onCheckboxClick: onSelect &&
            ((e) => {
                e.stopPropagation();
                onClick();
            }) }) })));
export default withStyles(styles)(MultiSelectFieldOption);
//# sourceMappingURL=MultiSelectFieldOption.js.map